import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const HeartWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
`;

const FloatingHeart = styled(motion.div)`
  position: absolute;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  opacity: ${props => props.opacity};
  z-index: ${props => props.zIndex};
  
  &:before,
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: ${props => props.color};
    border-radius: 50%;
  }
  
  &:before {
    top: -50%;
    left: 0;
  }
  
  &:after {
    top: 0;
    left: -50%;
  }
`;

const Heart = ({ size, left, delay, duration, color, opacity, zIndex }) => {
  return (
    <FloatingHeart
      size={size}
      color={color}
      opacity={opacity}
      zIndex={zIndex}
      initial={{ 
        x: left, 
        y: -100, 
        rotate: 45
      }}
      animate={{ 
        y: window.innerHeight + 100,
        rotate: [45, 55, 35, 55, 45]
      }}
      transition={{ 
        duration: duration,
        delay: delay,
        repeat: Infinity,
        ease: "linear"
      }}
    />
  );
};

const HeartAnimation = () => {
  const [hearts, setHearts] = useState([]);
  
  useEffect(() => {
    const colors = ['#ff4b8d', '#ff69b4', '#da70d6', '#ff1493', '#ff85a2'];
    const numHearts = Math.min(25, Math.floor(window.innerWidth / 50));
    const windowWidth = window.innerWidth;
    
    const newHearts = Array.from({ length: numHearts }).map((_, i) => ({
      id: i,
      size: Math.random() * 20 + 10,
      left: Math.random() * windowWidth,
      delay: Math.random() * 5,
      duration: Math.random() * 10 + 10,
      color: colors[Math.floor(Math.random() * colors.length)],
      opacity: Math.random() * 0.4 + 0.1,
      zIndex: Math.floor(Math.random() * 5)
    }));
    
    setHearts(newHearts);
  }, []);
  
  return (
    <HeartWrapper>
      {hearts.map(heart => (
        <Heart key={heart.id} {...heart} />
      ))}
    </HeartWrapper>
  );
};

export default HeartAnimation; 